import { render } from "./AuthBase.vue?vue&type=template&id=450ad119&scoped=true"
import script from "./AuthBase.vue?vue&type=script&lang=js"
export * from "./AuthBase.vue?vue&type=script&lang=js"

import "./AuthBase.vue?vue&type=style&index=0&id=450ad119&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450ad119"]])

export default __exports__